import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './JobsList.module.scss';
import {
  FIND_JOBS_LIST as jobsList,
  FIND_COUNTRIES_LIST as countriesList,
} from 'constants/findJobs';
import {
  fromSeoUrl,
  toPlural,
  toSeoUrl,
  toSingular,
} from 'helpers/HelperFunctions';
import JobsListItem from './JobsListItem';

const JobsList = ({ country, city, selectedRole, cityList }) => {
  const [listToRender, setListToRender] = useState();

  let linkSuffix = '';
  let locationText = '';
  let backLinks = [];

  if (country && !selectedRole) {
    linkSuffix = `/in/${toSeoUrl(country)}`;
    locationText = ` in ${fromSeoUrl(country)}`;
  }

  if (city && country) {
    linkSuffix = `/in/${toSeoUrl(country)}/${toSeoUrl(city)}`;
    locationText = ` in ${fromSeoUrl(city)}`;
  }

  if (city && !selectedRole) {
    backLinks.push({
      backLink: `/jobs/in/${toSeoUrl(country)}`,
      backLinkText: `Freelance jobs in ${fromSeoUrl(country)}`,
    });
  }

  if (country && selectedRole) {
    backLinks.push({
      backLink: `/jobs/${toSeoUrl(selectedRole)}`,
      backLinkText: `${toSingular(selectedRole)} jobs`,
    });
  }
  if (city && selectedRole) {
    backLinks.push({
      backLink: `/jobs/${toSeoUrl(selectedRole)}/in/${toSeoUrl(country)}`,
      backLinkText: `${toSingular(selectedRole)} jobs in ${fromSeoUrl(
        country
      )}`,
    });
  }

  const jobListToRender = jobsList.map((item, index) => (
    <JobsListItem
      link={`/jobs/${toSeoUrl(toPlural(item))}${linkSuffix}`}
      key={index + item}
      text={`${item} jobs${locationText}`}
    />
  ));

  const countryListToRender = countriesList.map((item, index) => (
    <JobsListItem
      key={index + item}
      link={`/jobs/${toSeoUrl(selectedRole)}/in/${toSeoUrl(item)}`}
      text={`${toSingular(selectedRole)} jobs in ${item}`}
    />
  ));

  const cityListToRender = cityList?.cities?.map((item, index) => (
    <JobsListItem
      key={index + item.city}
      link={`/jobs/${toSeoUrl(selectedRole)}/in/${toSeoUrl(country)}/${toSeoUrl(
        item.city
      )}`}
      text={`${toSingular(selectedRole)} jobs in ${item.city}`}
    />
  ));

  const rolesInCityList = jobsList.map((item, index) => (
    <JobsListItem
      link={`/jobs/${toSeoUrl(toPlural(item))}${linkSuffix}`}
      key={index + item}
      text={`${item} jobs${locationText}`}
    />
  ));

  const handleListToRender = () => {
    // When a city is selected browse more jobs should link  to other roles in that city FR-140
    if (city && cityList.loaded) {
      setListToRender(rolesInCityList);
      return;
    }

    // When a country and role are selected the browse more jobs should link the most popular cities in that country FR-139
    if (selectedRole && country && cityList.loaded) {
      setListToRender(cityListToRender);
      return;
    }

    // When a role is selected the browse more jobs should link to the country pages FR-138
    if (selectedRole && !country) {
      setListToRender(countryListToRender);
      return;
    }

    // When a country is selected but not a role the browse more jobs should link to the most popular roles FR-142
    if (country && !selectedRole) {
      setListToRender(jobListToRender);
    }

    setListToRender(jobListToRender);
    return;
  };

  useEffect(() => {
    handleListToRender();
  }, [selectedRole, country, city, cityList]);

  return (
    <div className={styles.jobsListContainer}>
      <p className={styles.jobsListTitle}>Browse more jobs</p>
      <ul>
        {backLinks.map((item, index) => (
          <li key={index + item}>
            <a href={item.backLink} className={styles.jobsListItem}>
              {item.backLinkText}
            </a>
          </li>
        ))}
        {listToRender}
      </ul>
    </div>
  );
};

JobsList.propTypes = {
  country: PropTypes.string,
  city: PropTypes.string,
  selectedRole: PropTypes.string,
  cityList: PropTypes.object,
};

export default JobsList;
